<ul
  #dropdownUl
  class="ant-select-dropdown-menu ant-select-dropdown-menu-root ant-select-dropdown-menu-vertical"
  role="menu"
  (keydown)="onKeyDownUl($event)"
  (scroll)="dropDownScroll($event,dropdownUl)"
  tabindex="0">
  <li
    *ngIf="isNotFoundDisplay"
    dw-select-unselectable
    class="ant-select-dropdown-menu-item ant-select-dropdown-menu-item-disabled">
    {{ dwNotFoundContent ? dwNotFoundContent : ('Select.notFoundContent' | dwI18n) }}
  </li>
  <li
    *ngIf="isAddTagOptionDisplay"
    dw-select-unselectable
    (click)="addTagOption()"
    class="ant-select-dropdown-menu-item ant-select-dropdown-menu-item-active">
    {{ dwSearchValue }}
  </li>
  <li
    dw-option-li
    [compareWith]="compareWith"
    *ngFor="let option of listOfDwOptionComponent | dwFilterOptionPipe : dwSearchValue : dwFilterOption : dwServerSearch "
    (click)="clickOption(option,false)"
    [dwActiveOption]="activatedOption"
    [dwOption]="option"
    [dwListOfSelectedValue]="dwListOfSelectedValue">
  </li>
  <li
    *ngFor="let group of listOfDwOptionGroupComponent | dwSubFilterOptionPipe : dwSearchValue : dwFilterOption : dwServerSearch"
    class="ant-select-dropdown-menu-item-group">
    <div
      class="ant-select-dropdown-menu-item-group-title"
      [attr.title]="group.isLabelString ? group.dwLabel : ''">
      <ng-container *ngIf="group.isLabelString; else labelTemplate">{{ group.dwLabel }}</ng-container>
      <ng-template #labelTemplate>
        <ng-template [ngTemplateOutlet]="group.dwLabel"></ng-template>
      </ng-template>
    </div>
    <ul class="ant-select-dropdown-menu-item-group-list">
      <li
        dw-option-li
        [compareWith]="compareWith"
        *ngFor="let option of group.listOfDwOptionComponent | dwFilterOptionPipe : dwSearchValue : dwFilterOption : dwServerSearch"
        (click)="clickOption(option,false)"
        [dwActiveOption]="activatedOption"
        [dwShowActive]="!isAddTagOptionDisplay"
        [dwOption]="option"
        [dwListOfSelectedValue]="dwListOfSelectedValue">
      </li>
    </ul>
  </li>
  <li
    dw-option-li
    [compareWith]="compareWith"
    *ngFor="let option of listOfTagOption | dwFilterOptionPipe : dwSearchValue : dwFilterOption : dwServerSearch "
    (click)="clickOption(option,false)"
    [dwActiveOption]="activatedOption"
    [dwShowActive]="!isAddTagOptionDisplay"
    [dwOption]="option"
    [dwListOfSelectedValue]="dwListOfSelectedValue">
  </li>
</ul>